export const EMAILVERIFIEDBYANOTHERUSER = "EMAILVERIFIEDBYANOTHERUSER";
export const USERNAMENOTUNIQUE = "USERNAMENOTUNIQUE";